import { useGetEngineFiscalRulesQuery } from "@/services/engine-fiscal-rules";
import { Load } from "components/load";
import PageError from "components/page-error";
import { RefreshCw } from "lucide-react";
import React from "react";
import { columns } from "../components/columns";
import { DataTable } from "../components/data-table";
import { useFilterState } from "../ducks/hooks/state";
import { ContentContainer, PageLayout, PageTitle } from "components/layout";
import { Button } from "components/ui/button";

export const CalculationBasis: React.FC = () => {
  const filterState = useFilterState();

  const baseFilters = {
    meta: {
      page: filterState.filters.meta?.page || 1,
      perPage: filterState.filters.meta?.perPage || 10,
    },
  };

  const dynamicFilters = Object.entries(filterState.filters).reduce(
    (acc, [key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        acc[key] = value;
      }
      return acc;
    },
    {} as Record<string, unknown>
  );

  const filters = { ...baseFilters, ...dynamicFilters };

  const {
    data: calculationBasis,
    isLoading,
    isFetching,
    error,
    refetch,
  } = useGetEngineFiscalRulesQuery(filters);

  const { data, meta } = calculationBasis || {
    data: [],
    meta: { page: 1, perPage: 10, total: 0, totalPages: 0 },
  };

  if (isLoading) return <Load />;
  if (error) return <PageError status={500} message="Erro ao buscar dados" />;
  return (
    <PageLayout>
      <PageTitle
        title="Alíquota Base"
        description="Gerencie as regras de cálculo de alíquota base do motor fiscal"
      />
      <ContentContainer>
        <div className="flex flex-row gap-2 justify-end mb-2">
          <Button
            className="px-4 py-2 border border-gray-300 flex items-center gap-2 rounded-md
          text-gray-700 bg-white
          transition-all duration-300 ease-in-out
          hover:bg-gray-100 hover:border-gray-400
          focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50"
            onClick={() => refetch()}
            disabled={isLoading}
          >
            <RefreshCw className="w-5 h-5" />
            Atualizar dados
          </Button>
        </div>
        <DataTable data={data} columns={columns} meta={meta} isLoading={isFetching} />
      </ContentContainer>
    </PageLayout>
  );
};
